const config = require("./config");

module.exports = {
    origin: require("./api.node.origin"),
    cross: require("./api.node.cross"),
    config,
};


// WEBPACK FOOTER //
// src/utils/api/node/index.js